import React from "react"
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogClose,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/src/components/ui/Dialog"
import { Spinner } from "../../LoadingSpinner"

type EditSelfReminderFormDialogProps = {
    isProcessing: boolean,
    isValid: boolean,
    onSave: (e: React.MouseEvent<HTMLButtonElement>) => void,
    onCancel: (e: React.MouseEvent<HTMLButtonElement>) => void,
}

const EditSelfReminderFormDialog: React.FC<EditSelfReminderFormDialogProps> = ({
    isProcessing, isValid,
    onSave, onCancel
}: EditSelfReminderFormDialogProps) => {
    return (
        <>
            <Dialog open={isProcessing}>
                <DialogTrigger asChild>
                    <button
                        className={`${isValid ? 'bg-primary-blue text-white active:bg-bright-light-blue': 'bg-slate-100 text-slate-300'} p-3 rounded-xl mb-2 w-full`}
                        onClick={onSave} disabled={!isValid}
                    >บันทึก</button>
                </DialogTrigger>
                <DialogContent className="bg-white rounded-2xl flex flex-col justify-center items-center gap-3">
                    <Spinner className="text-blue-700" />
                    <span className="text-base text-blue-700 leading-[22px]">กำลังประมวลผล</span>
                </DialogContent>
            </Dialog>
            <Dialog>
                <DialogTrigger asChild>
                    <button
                        className="border-2 bg-white text-primary-cancel-red p-3 rounded-xl active:bg-primary-cancel-dark-red active:text-white"
                    >ลบการแจ้งเตือน</button>
                </DialogTrigger>
                <DialogContent className="bg-white rounded-2xl">
                    <DialogHeader>
                        <DialogTitle className="text-2xl text-center">
                            คุณต้องการลบการแจ้งเตือนนี้<br />หรือไม่?
                        </DialogTitle>
                        <DialogDescription className="text-md font-light text-left">
                            คุณจะไม่ได้รับข้อความแจ้งเตือนอีก
                        </DialogDescription>
                    </DialogHeader>
                    <div className="flex flex-col gap-2">
                    <button
                        className="bg-primary-blue text-white p-3 rounded-xl active:bg-bright-light-blue font-medium w-full"
                        type="submit"
                        onClick={onCancel}
                        disabled={isProcessing}
                    >ยืนยันการลบ</button>
                        <DialogClose asChild>
                            <button className="border-2 text-primary-blue p-3 rounded-xl active:bg-bright-light-blue active:text-white font-medium">ย้อนกลับ</button>
                        </DialogClose>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default EditSelfReminderFormDialog;
export type { EditSelfReminderFormDialogProps };